<template>
  <router-view />
</template>

<script>
import api from '@/api';
import store from '@/store';
import router from '@/router';

export default {
  name: "App",

  data() {
    return {
      checkStatusInterval: null
    };
  },

  async mounted() {

    // 1. Recharge user au démarrage si token existe
    if (store.state.token) {
      await store.dispatch("refreshUser");
    }

    // 2. Vérification périodique
    this.checkStatusInterval = setInterval(async () => {

      const token = store.state.token;

      if (!token) return;

      try {

        // ✅ FIX ICI : utiliser getMe()
        const response = await api.getMe();
        const freshUser = response.data;

        // ❌ compte désactivé
        if (freshUser.enabled === false) {

          store.dispatch("logout");

          clearInterval(this.checkStatusInterval);

          router.push({
            path: '/login',
            query: { message: 'Votre compte a été désactivé.' }
          });
        }

      } catch (error) {
        console.error("Erreur vérification status utilisateur :", error);
      }

    }, 60000);

  },

  beforeUnmount() {
    clearInterval(this.checkStatusInterval);
  }
};
</script>